import { Text } from '@mattilsynet/mt-ui';
import React from 'react';
interface IHentFraKollegaBekreftViewProps {
  kollega: string;
}
export const HentFraKollegaBekreftView = ({
  kollega
}: IHentFraKollegaBekreftViewProps) => <Text data-sentry-element="Text" data-sentry-component="HentFraKollegaBekreftView" data-sentry-source-file="index.tsx">{kollega} vil bli informert om at du har hentet tilsynkvittering.</Text>;